module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/sync-40f381ada71c1f4fa05c84d3a2a1275c.svg";